(function (angular) {
    "use strict";

    angular
    .module("alk.services")
    .factory("mapTextPath", ["_", function (_) {


        var svgNS = "http://www.w3.org/2000/svg";

        function getCoordArray(feature, toLL) {
            var theseCoords = angular.copy(feature.geometry.components);
            toLL = toLL || false;
            var coords = _.map(theseCoords, function (c) {
                if (toLL && (c.x > 180 || c.x < -180)) {
                    var tempLL = new ALKMaps.LonLat(c.x, c.y).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
                    c.x = tempLL.lon;
                    c.y = tempLL.lat;
                }
                return [c.x, c.y];
            });
            return coords;
        }

        function convertPolyToPath(polyline, id) {
            var thisNS = polyline.ownerSVGElement.namespaceURI;
            var path = document.createElementNS(thisNS, "path");
            var points = polyline.getAttribute("points").split(/\s+|,/);
            var x0 = points.shift(), y0 = points.shift();
            var pathdata = "M" + x0 + "," + y0 + "L" + points.join(" ");
            if (polyline.tagName === "polygon") pathdata += "z";
            path.setAttribute("d", pathdata);
            path.setAttribute("id", id);
            path.setAttribute("fill", "none");
            //polyline.parentNode.appendChild(path);
            return path;
        }

        function setText(feature, text, options, redraw) {
            if (!feature._textElements) feature._textElements = [];
            if (document.getElementById(feature.geometry.id) !== null) {
                var defaults = {
                    repeat: false,
                    fillColor: "black",
                    attributes: {},
                    below: false,
                    position: "middle",
                    autoRotate: true,
                };
                options = _.assign(defaults, options);

                feature._pathid = feature.geometry.id + "_path";
                var _path = document.getElementById(feature._pathid);

                if (_path === null) {
                    _path = convertPolyToPath(document.getElementById(feature.geometry.id), feature._pathid);
                }
                var svg = document.getElementById(feature.geometry.id).parentNode;
                svg.appendChild(_path);
                /* Put it along the path using textPath */
                var textNode = document.createElementNS(svgNS, "text"),
                    textPath = document.createElementNS(svgNS, "textPath");

                textNode.setAttribute("class", "textpath textpath-" + feature.geometry.id);

                //textPath.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", window.location.href + "#" + feature._pathid);
                textPath.setAttribute("href", window.location.href + "#" + feature._pathid);

                var dx = options.attributes.dx || "0";
                var dy = options.attributes.dy || _path.getAttribute("stroke-width");

                textNode.setAttribute("dx", dx);
                textNode.setAttribute("dy", dy);

                for (var attr in options.attributes) textNode.setAttribute(attr, options.attributes[attr]);
                textPath.appendChild(document.createTextNode(text));
                textNode.appendChild(textPath);

                if (options.below) {
                    svg.insertBefore(textNode, svg.firstChild);
                }
                else {
                    svg.appendChild(textNode);
                }

                /* Center text according to the path"s bounding box */
                if (options.center) {
                    var textWidth = textNode.getBBox().width;
                    var pathWidth = _path.getBoundingClientRect().width;
                    /* Set the position for the left side of the textNode */
                    textNode.setAttribute("dx", ((pathWidth / 2) - (textWidth / 2)));
                }

                if (options.position === "middle") {
                    textNode.setAttribute("text-anchor", "middle");
                    textPath.setAttribute("startOffset", "50%");
                }

                if (options.position === "right") {
                    textNode.setAttribute("text-anchor", "end");
                    textPath.setAttribute("startOffset", "100%");
                }

                if (options.autoRotate) {
                    var pathPoints = getCoordArray(feature);
                    var x1 = pathPoints[0][0], x2 = pathPoints[pathPoints.length - 1][0];
                    if (x1 < 0) x1 += 360;
                    if (x2 < 0) x2 += 360;
                    if (x1 - x2 > 0) {
                        var textBBox = textNode.getBBox();
                        var textNodeCenter = {
                            x: textBBox.x + (textBBox.width / 2),
                            y: textBBox.y + (textBBox.height / 2)
                        };
                        textNode.setAttribute("transform", "rotate(180 " + textNodeCenter.x + "," + textNodeCenter.y + ")");
                    }
                }

                if (!redraw) {
                    feature._textElements.push(
                        {
                            text: text,
                            options: options
                        });
                }
            }
        }

        function removeText(feature, temp) {
            temp = temp || false;

            if (feature && feature.layer == null) {
                console.log("feature.layer is null when attempting to remove text")
            }

            if (feature && feature.layer) {
                feature.layer.redraw();
                var pathEl = document.getElementById(feature._pathid);
                if (pathEl !== null) {
                    var nodeClass = "textpath textpath-" + feature.geometry.id;
                    var parent = document.getElementById(feature._pathid).parentNode;
                    var textElems = document.getElementsByClassName(nodeClass);
                    for (var el = textElems.length - 1; el > -1; el--) {
                        parent.removeChild(textElems[el]);
                    }
                    var pathElem = document.getElementById(feature._pathid);
                    parent.removeChild(pathElem);
                    if (!temp) {
                        feature._textElements = null;
                    }
                }
            }
        }

        return {
            add: setText,
            remove: removeText
        }
    }]);

})(window.angular);


// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/Maps/mapsTextPath.js